import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import DisableCartLayoutModal from './DisableCartLayoutModal';

import { Button, Text, H3, Panel, Dropdown, Small, Tabs, Table, Box } from '@bigcommerce/big-design';
import { ArrowDropDownIcon, AddIcon, EditIcon, DeleteIcon } from '@bigcommerce/big-design-icons';

import { cartLayoutsIndex } from '../../redux/actions/cartLayouts';


const CartLayouts = ({ payload, cartLayouts, loadCartLayouts }) => {  
  const [submitted, setSubmitted] = useState(false);
  const [activeCartLayout, setActiveCartLayout] = useState(null);
  const [showDisableCartLayoutModal, setShowDisableCartLayoutModal] = useState(false);


  useEffect(() => {
    loadCartLayouts(payload);
  }, []);

  const showDisableModal = (id) => {
    let layout = cartLayouts.cartLayouts.find(layout => layout.id.split("#")[1] === id);

    console.log(layout);

    setActiveCartLayout(layout);
    setShowDisableCartLayoutModal(true);
  }

  const actionButtons = (id) => {
    let idOnly = id.split("#")[1];

    return(
      <>
        <Link to={`/cart_layouts/edit/${idOnly}`}>
          <Button
            variant="secondary"
            iconLeft={<EditIcon />}
            disabled={submitted}
            isLoading={submitted}
          >
            Edit
          </Button>
        </Link>
        <Button
          onClick={() => showDisableModal(idOnly)}
          variant="secondary"
          actionType="destructive"
          iconLeft={<DeleteIcon />}
          disabled={submitted}
          isLoading={submitted}
        >
          Disable
        </Button>
      </>
    )
  }

  const description = () => {
    return(
      <> 
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return (
    <>
      <PageHeader stripeBackground='#2c9c7c' helpLink="" />
      <SettingsPage title="Cart Layouts" description={description()}>
        <Panel>
          <H3>Cart Layouts</H3>

          { cartLayouts.status === 'success' && cartLayouts.cartLayouts.length > 0 &&
            <>
              <Table
                columns={[
                  { header: 'Label', hash: 'label', render: ({ label }) => label },
                  { header: 'Rows', hash: 'rows', render: ({ rows }) => rows },
                  { header: 'Columns', hash: 'columns', render: ({ columns }) => columns },
                  { header: 'Actions', hash: 'actions', render: ({ id }) => actionButtons(id) },
                ]}
                items={cartLayouts.cartLayouts}
                stickyHeader
              />
              <hr/>
              <Link to="/cart_layouts/new">
                <Button
                  iconLeft={<AddIcon />}
                  isLoading={submitted}
                  disabled={submitted}
                >
                  New Cart Layout
                </Button>
              </Link>
            </>
          }

          { cartLayouts.status !== 'success' &&
            <LoadingSpinner size="xxSmall" statusText="Loading cart layouts"/>
          }

          { cartLayouts.status === 'success' && cartLayouts.cartLayouts.length === 0 &&
            <Box
              backgroundColor="warning10"
              border="box"
              borderRadius="normal"
              padding="medium"
            >
              <div className="text-center">
                <Text>No cart layouts set. Create cart layouts to see and manage them here.</Text>
                <Link to="/cart_layouts/new">
                  <Button
                    iconLeft={<AddIcon />}
                    isLoading={submitted}
                    disabled={submitted}
                  >
                    New Cart Layout
                  </Button>
                </Link>
              </div>
            </Box>
          }

        </Panel>
      </SettingsPage>

      <DisableCartLayoutModal
        payload={payload}
        showDisableCartLayoutModal={showDisableCartLayoutModal}
        setShowDisableCartLayoutModal={setShowDisableCartLayoutModal}
        cartLayout={activeCartLayout}
        cartLayoutId={activeCartLayout?.id.split("#")[1]}
      />
    </>
  )
}

const mapStateToProps = state => ({
  cartLayouts: state.cartLayouts,
});

const mapDispatchToProps = (dispatch) => ({
  loadCartLayouts: (payload) => dispatch(cartLayoutsIndex(payload)),

});

export default connect(mapStateToProps, mapDispatchToProps)(CartLayouts);